import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const scoreRecord = async (params: object) => {
  return await GET({ url: Api.courierAttendScoreChangeRecord, params, showError: false })
}
